import { render, staticRenderFns } from "./mediaTagSelector.vue?vue&type=template&id=0d9d55f4&scoped=true&"
import script from "./mediaTagSelector.vue?vue&type=script&lang=js&"
export * from "./mediaTagSelector.vue?vue&type=script&lang=js&"
import style0 from "./mediaTagSelector.vue?vue&type=style&index=0&id=0d9d55f4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9d55f4",
  null
  
)

export default component.exports